/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListForumThreads200ResponseDataInner } from './ListForumThreads200ResponseDataInner';
import {
    ListForumThreads200ResponseDataInnerFromJSON,
    ListForumThreads200ResponseDataInnerFromJSONTyped,
    ListForumThreads200ResponseDataInnerToJSON,
    ListForumThreads200ResponseDataInnerToJSONTyped,
} from './ListForumThreads200ResponseDataInner';
import type { ListForumThreads200ResponseLinks } from './ListForumThreads200ResponseLinks';
import {
    ListForumThreads200ResponseLinksFromJSON,
    ListForumThreads200ResponseLinksFromJSONTyped,
    ListForumThreads200ResponseLinksToJSON,
    ListForumThreads200ResponseLinksToJSONTyped,
} from './ListForumThreads200ResponseLinks';
import type { ListForumThreads200ResponseMeta } from './ListForumThreads200ResponseMeta';
import {
    ListForumThreads200ResponseMetaFromJSON,
    ListForumThreads200ResponseMetaFromJSONTyped,
    ListForumThreads200ResponseMetaToJSON,
    ListForumThreads200ResponseMetaToJSONTyped,
} from './ListForumThreads200ResponseMeta';

/**
 * 
 * @export
 * @interface ListForumThreads200Response
 */
export interface ListForumThreads200Response {
    /**
     * 
     * @type {Array<ListForumThreads200ResponseDataInner>}
     * @memberof ListForumThreads200Response
     */
    data?: Array<ListForumThreads200ResponseDataInner>;
    /**
     * 
     * @type {ListForumThreads200ResponseLinks}
     * @memberof ListForumThreads200Response
     */
    links?: ListForumThreads200ResponseLinks;
    /**
     * 
     * @type {ListForumThreads200ResponseMeta}
     * @memberof ListForumThreads200Response
     */
    meta?: ListForumThreads200ResponseMeta;
}

/**
 * Check if a given object implements the ListForumThreads200Response interface.
 */
export function instanceOfListForumThreads200Response(value: object): value is ListForumThreads200Response {
    return true;
}

export function ListForumThreads200ResponseFromJSON(json: any): ListForumThreads200Response {
    return ListForumThreads200ResponseFromJSONTyped(json, false);
}

export function ListForumThreads200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListForumThreads200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ListForumThreads200ResponseDataInnerFromJSON)),
        'links': json['links'] == null ? undefined : ListForumThreads200ResponseLinksFromJSON(json['links']),
        'meta': json['meta'] == null ? undefined : ListForumThreads200ResponseMetaFromJSON(json['meta']),
    };
}

export function ListForumThreads200ResponseToJSON(json: any): ListForumThreads200Response {
    return ListForumThreads200ResponseToJSONTyped(json, false);
}

export function ListForumThreads200ResponseToJSONTyped(value?: ListForumThreads200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ListForumThreads200ResponseDataInnerToJSON)),
        'links': ListForumThreads200ResponseLinksToJSON(value['links']),
        'meta': ListForumThreads200ResponseMetaToJSON(value['meta']),
    };
}

